/* eslint-disable react/react-in-jsx-scope */
import { Button, Typography } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ClearIcon from '@mui/icons-material/Clear';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

export default function DateRangePicker({
  loading,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  disableFutureDates,
  TransferIntakeTable,
  heading,
  ClearData,
  page,
  offSideMargin,
}) {
  return (
    <div className="container-fluid row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div
        className="gap-1 p-2"
        id="datePicker_id2"
        style={{
          marginBottom: '-90px',
          marginTop: heading !== '' ? '-80px' : '-60px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: page === 'Unauthorize' && '750px',
          marginLeft: offSideMargin,
        }}
      >
        <Typography variant="h6" sx={{ display: heading !== '' ? 'block' : 'none', textAlign: 'center' }}>
          {heading}
        </Typography>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Typography variant="h6">From</Typography>
          <DatePicker
            disabled={loading}
            className="border border-gray-400 p-2 rounded-md text-gray-800 text-sm"
            dateFormat="yyyy-MM-dd"
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText="YYYY-MM-DD"
            autoComplete="off"
            filterDate={disableFutureDates}
            excludeDates={page === 'Unauthorize' ? null : [new Date()]}
          />
          <Typography variant="h6">To</Typography>
          <DatePicker
            disabled={loading}
            className="border border-gray-400 p-2 rounded-md text-gray-800 text-sm"
            dateFormat="yyyy-MM-dd"
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText="YYYY-MM-DD"
            autoComplete="off"
            filterDate={disableFutureDates}
            excludeDates={page === 'Unauthorize' ? null : [new Date()]}
          />
          {/* <Button
            onClick={TransferIntakeTable}
            variant="contained"
            size="medium"
            sx={{ width: '200px' }}
          >
            Search
          </Button> */}
          <Button
            onClick={TransferIntakeTable}
            style={{
              background: '#f1f3f6',
              color: '#2563eb', // blue for search
              borderRadius: '10px',
              padding: '6px 16px',
              fontWeight: '600',
              boxShadow: '6px 6px 12px #d1d9e6, -6px -6px 12px #ffffff',
              border: 'none',
              textTransform: 'none',
              minWidth: '100px',
            }}
          >
            <SearchOutlinedIcon style={{ marginRight: '6px' }} />
            Search
          </Button>
          {page === 'Unauthorize' && (
          <Button
            onClick={ClearData}
            style={{
              background: '#f1f3f6',
              color: '#e63946', // red for clear
              borderRadius: '10px',
              padding: '6px 16px',
              fontWeight: '600',
              boxShadow: '6px 6px 12px #d1d9e6, -6px -6px 12px #ffffff',
              border: 'none',
              textTransform: 'none',
              marginLeft: '10px',
              minWidth: '100px',
            }}
          >
            <ClearIcon style={{ marginRight: '6px' }} />
            Clear
          </Button>
          )}

        </div>
      </div>
    </div>
  );
}
